export default "__VITE_ASSET__8b0e9bfa__"